import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import data, { iconSize, urlapi } from '../../lib/backend/data'
import PantallaCargando from '../general/pantalla_cargando';
import { Button, Card, Col, Modal, Row, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IoMdNotificationsOutline } from 'react-icons/io';
import { url_images } from '../../lib/global/data';
import { TiFlowSwitch, TiFlowParallel } from "react-icons/ti";
import { FaEdit, FaPlus } from 'react-icons/fa';

const FlujosEstadosCarga = (props) => {

    const [ flujos, setFlujos ] = useState([])
    const [ nuevoFlujo, setNuevoFlujo ] = useState({})
    const [ estadosCarga, setEstadosCarga ] = useState([])
    const [ subEstadosCarga, setSubEstadosCarga ] = useState([])
    const [ loadingEstadosCarga, setLoadingEstadosCarga ] = useState(true)
    const [ loadingFlujos, setLoadingFlujos ] = useState(true)
    const [ loadingCreacionFlujo, setLoadingCreacionFlujo ] = useState(false)
    const [ loadingCreacionSegmento, setLoadingCreacionSegmento ] = useState(false)
    const [ clienteConsultar, setClienteConsultar ] = useState({ value: props.owner, label: '' })
    const [ idGuardandoSegmento, setGuardandoSegmento ] = useState(false)
    const [ idGuardandoFlujo, setGuardandoFlujo ] = useState(false)
    const [ showModal, setShowModal ] = useState(false)
    const [ tipos_servicio, setTipoServicio ] = useState([])
    const [ loadingTiposServicio, setLoadingTipoServicio ] = useState(true)
    const session = useSelector(state => state.miusuario)

    useEffect(() => {
        getFlujos()
        setEstadosCarga([])
        obtenerEstados()
        getConfiguracion('logistica','tipos-servicio')
    }, [])
    
    const getConfiguracion = (tipo, subtipo) => {
        setLoadingTipoServicio(true)
        return fetch(`${urlapi}/configuracion/tipo?tipo=${tipo}&subtipo=${subtipo}`,{
            method: "GET",
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            },
        })
        .then(pros => pros.json())
        .then(data => { 
            console.log(data)
            if(data.errorMessage){
                toast.error(data.errorMessage)
                return setLoadingTipoServicio(false)
            } else if(Array.isArray(data) !== false){
                if(data.length > 0){
                    const datos = data.map(e => ({ value: e._id, label: e.valor }))
                    setTipoServicio(datos)
                }
            }
            return setLoadingTipoServicio(false)
        })
        .catch(error => {
            toast.error('No pudimos cargar la información')
            return setLoadingTipoServicio(false)
        })
    }

    const showByTipoServicio = (tipo) => tipo

    const handleChangeNuevoFlujo = (e) => {
        const { name, value } = e.target
        nuevoFlujo[name] = value
        return setNuevoFlujo(nuevoFlujo)
    }

    const handleChangeSelectEstadoCarga = (e,id_segmento,id_flujo) => {
        const i_flujo = flujos.findIndex(flu => flu.flujo._id === id_flujo)
        const i_segmento = flujos[i_flujo].segmentos.findIndex(seg => seg._id === id_segmento)
        flujos[i_flujo].segmentos[i_segmento].estado_requerido = e.value
        return setFlujos(flujos)
    }
    const handleChangeSelectEstadosDisponibles = (e,id_segmento,id_flujo) => {
        let opciones = []
        if(e){
            e.map(valor => {
                opciones.push(valor.value)
            })
        }
        const i_flujo = flujos.findIndex(flu => flu.flujo._id === id_flujo)
        const i_segmento = flujos[i_flujo].segmentos.findIndex(seg => seg._id === id_segmento)
        flujos[i_flujo].segmentos[i_segmento].estados_disponibles = opciones
        return setFlujos(flujos)
    }

    const handleChangeSelectTipoServicio = (e) => {
        let opciones = []
        if(e){
            e.map(valor => {
                opciones.push(valor.value)
            })
        }
        nuevoFlujo.tipos_servicio = opciones
        return setNuevoFlujo(nuevoFlujo)
    }

    const handleChangeEditarFlujo = (e) => {
        const { name, value } = e.target
        const id_flujo = e.target.getAttribute('idflujo')
        console.log(id_flujo)
        const i_flujo = flujos.findIndex(flu => flu.flujo._id === id_flujo)
        flujos[i_flujo].flujo[name] = value
        return setFlujos(flujos)
    }

    const handleChangeSelectTipoServicioEditar = (e,id_flujo) => {
        let opciones = []
        if(e){
            e.map(valor => {
                opciones.push(valor.value)
            })
        }
        const i_flujo = flujos.findIndex(flu => flu.flujo._id === id_flujo)
        flujos[i_flujo].flujo.tipos_servicio = opciones
        return setFlujos(flujos)
    }

    const obtenerEstados = async () => {
        setLoadingEstadosCarga(true)
        return fetch(`${data.urlapi}/estadoscarga/details`,{
            method: "GET",
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            }
        })
        .then(pros => pros.json())
        .then(data => { 
            if(data.errorMessage){
                toast.error(data.errorMessage)
                return setLoadingEstadosCarga(false)
            }
            // if(data.estados.length < 1) toast.warn('No hay estados de carga para este cliente')
            if(Array.isArray(data.estados) !== false) setEstadosCarga(data.estados)
            if(Array.isArray(data.subestados) !== false) setSubEstadosCarga(data.subestados)
            setLoadingEstadosCarga(false)
        })
        .catch(error => {
            toast.error('No pudimos cargar la información')
            setLoadingEstadosCarga(false)
        })
    }

    const crearFlujo = () => {
        const requeridos = [
            { value:'titulo', label: 'Título' },
            { value:'descripcion', label: 'Descripción' },
            { value:'tipos_servicio', label: 'Tipos de servicio' },
        ]
        let faltantes = []
        requeridos.map(campo => {
            if(!nuevoFlujo[campo.value]) faltantes.push(campo.label)
            return true
        })
        if(faltantes.length > 0) return toast.error(`Faltan campos: ${faltantes.join(', ')}`)
        setLoadingCreacionFlujo(true)
        return fetch(`${data.urlapi}/estadoscarga/flujos`,{
            method:'POST',
            body: JSON.stringify( nuevoFlujo ),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            }
        })
        .then(res => res.json())
        .then(res => {
            if(!res){
                toast.error('Sin respuesta del servidor')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res.flujo){ 
                toast.success('Guardado exitosamente')
                flujos.push(res)
                setFlujos(flujos)
                setShowModal(false)
            } else {
                toast.error('Ocurrió un error inesperado')
            }
            setLoadingCreacionFlujo(false)
        })
        .catch(error => {
            setLoadingCreacionFlujo(false)
            toast.error("Error al realizar esta operación, intente nuevamente")
        })
    }

    const agregarSegmento = async (idflujo) => {
        setLoadingCreacionSegmento(true)
        return fetch(`${data.urlapi}/estadoscarga/flujos/segmentos`,{
            method:'POST',
            body: JSON.stringify( {
                idflujo
            } ),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            }
        })
        .then(res => res.json())
        .then(res => {
            console.log(res)
            if(res._id){ 
                toast.success('Guardado exitosamente')
                const i = flujos.findIndex(flu => flu.flujo._id === idflujo)
                flujos[i].segmentos.push(res)
                setFlujos(flujos)
            } else {
                toast.error('Ocurrió un error inesperado')
            }
            setLoadingCreacionSegmento(false)
        })
        .catch(error => {
            console.log(error)
            setLoadingCreacionSegmento(false)
            toast.error("Error al realizar esta operación, intente nuevamente")
        })
    }

    const getFlujos = () => {
        setLoadingFlujos(true)
        const url = `${data.urlapi}/estadoscarga/flujos/list`;
        return fetch(url,{
            method: "GET",
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            }
        })
        .then(pros => pros.json())
        .then(pros => {
            if(!pros){
                toast.error('Ocurrió un error inesperado, Sin respuesta del servidor')
                return setLoadingFlujos(false)
            } else if(pros.errorMessage){
                toast.error(`Ocurrió un error inesperado: ${pros.errorMessage}`, )
                return setLoadingFlujos(false)
            }
            if(Array.isArray(pros) !== false) setFlujos(pros)
            setLoadingFlujos(false)
        })
        .catch(error => {
            console.log(error)
            toast.error('Ocurrió un error inesperado')
            setLoadingFlujos(false)
        })
    }

    const handleChangeSelectClientev2 = (e) => {
        return setClienteConsultar(e)
    }

    const formulario_crear_flujo = () => {
        return <div>
            <div className='row'>
                <div className='col-md-12 mb-2'>
                    <label className='form-control-label d-block'>Título</label>
                    <input className='form-control' name="titulo" placeholder='Escribe un nombre corto para recordar este flujo' onChange={handleChangeNuevoFlujo} />
                </div>
                <div className='col-md-12 mb-2'>
                    <label className='form-control-label d-block'>Descripción</label>
                    <input className='form-control' name="descripcion" placeholder='Describe este flujo' onChange={handleChangeNuevoFlujo} />
                </div>
                <div className='col-md-12 mb-2'>
                    <label className='form-control-label d-block'>Descripción</label>
                    <Select 
                    style={{ marginBottom: 10 }}
                    onChange={handleChangeSelectTipoServicio}
                    options={tipos_servicio}
                    isMulti={true}
                    placeholder="Tipo de servicio..."
                    />
                </div>
                <div className='col-md-12 mb-2'>
                    <label className='form-control-label d-block'>Click para crear</label>
                    {
                        loadingCreacionFlujo === true ? <Spinner animation='border' /> : <Button variant="success" className='w-100' onClick={()=>crearFlujo()}>CREAR</Button>
                    }
                    
                </div>
            </div>
        </div>
    }

    const mostrarTiposServicioConcatenados = (tipos_servicio) => {
        if(!tipos_servicio) return false
        if(Array.isArray(tipos_servicio) !== true) return false
        if(tipos_servicio.length < 1) return false
        return tipos_servicio.map(tipo => <span className='spanguia mr-2' style={{ fontSize: 11 }}>{showByTipoServicio(tipo)}</span>)
    }

    const guardarCambiosSegmento = (segmento) => {
        setGuardandoSegmento(segmento._id)
        return fetch(`${data.urlapi}/estadoscarga/flujos/segmentos`,{
            method:'PUT',
            body: JSON.stringify( segmento ),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            }
        })
        .then(res => res.json())
        .then(res => {
            if(res._id){ 
                toast.success('Guardado exitosamente')
            } else {
                toast.error('Ocurrió un error inesperado')
            }
            setGuardandoSegmento(false)
        })
        .catch(error => {
            setGuardandoSegmento(false)
            toast.error("Error al realizar esta operación, intente nuevamente")
        })
    }

    const eliminarSegmento = async (id, idflujo) => {
        setGuardandoSegmento(id)
        return fetch(`${data.urlapi}/estadoscarga/flujos/segmentos?id=${id}`,{
            method:'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            }
        })
        .then(res => res.json())
        .then(res => {
            if(!res){
                toast.error('No se obtuvieron datos del servidor')
            } else if(res.errorMessage){ 
                toast.success(res.errorMessage)
            } else if(res._id){ 
                const i_flujo = flujos.findIndex(flu => flu.flujo._id === idflujo)
                const i_segmento = flujos[i_flujo].segmentos.findIndex(seg => seg._id === id)
                flujos[i_flujo].segmentos.splice(i_segmento,1)
                setFlujos(flujos)
                toast.success('Eliminado exitosamente')

            }
            setGuardandoSegmento(false)
        })
        .catch(error => {
            setGuardandoSegmento(false)
            toast.error("Error al realizar esta operación, intente nuevamente")
        })
    }
    const eliminarFlujo = async (id) => {
        setGuardandoFlujo(id)
        return fetch(`${data.urlapi}/estadoscarga/flujos?id=${id}`,{
            method:'DELETE',
        })
        .then(res => res.json())
        .then(res => {
            if(!res){
                toast.error('No se obtuvieron datos del servidor')
            } else if(res.errorMessage){ 
                toast.success(res.errorMessage)
            } else if(res._id){ 
                const i_flujo = flujos.findIndex(flu => flu.flujo._id === id)
                flujos.splice(i_flujo,1)
                setFlujos(flujos)
                toast.success('Eliminado exitosamente')

            }
            setGuardandoFlujo(false)
        })
        .catch(error => {
            setGuardandoFlujo(false)
            toast.error("Error al realizar esta operación, intente nuevamente")
        })
    }

    const solicitarEliminarFlujo = (id) => {
        return confirmAlert({
            title: '¿Estás seguro?',
            message: `¿Deseas eliminar este item? Esta opción no se puede deshacer`,
            buttons: [
              {
                label: 'CONFIRMAR',
                onClick: () => eliminarFlujo(id)
              },
              {
                label: 'CANCELAR',
                onClick: () => false
              },
            ],
          })
    } 

    const actualizarFlujo = async (flujo) => {
        setGuardandoFlujo(flujo._id)
        return fetch(`${data.urlapi}/estadoscarga/flujos`,{
            method:'PUT',
            body: JSON.stringify( flujo ),
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then(res => res.json())
        .then(res => {
            if(!res){
                toast.error('No se obtuvo respuesta del servidor')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res._id){ 
                toast.success('Guardado exitosamente')
                editarFlujo(res._id, false)
            }
            setGuardandoFlujo(false)
        })
        .catch(error => {
            setGuardandoFlujo(false)
            toast.error("Error al realizar esta operación, intente nuevamente")
        })
    }

    const solicitarEliminarSegmento = (id, idflujo) => {
        return confirmAlert({
            title: '¿Estás seguro?',
            message: `¿Deseas eliminar este item? Esta opción no se puede deshacer`,
            buttons: [
              {
                label: 'CONFIRMAR',
                onClick: () => eliminarSegmento(id, idflujo)
              },
              {
                label: 'CANCELAR',
                onClick: () => false
              },
            ],
          })
    } 

    const handleCancel = () => {
        setShowModal(false)
    }

    const modalCreacion = () => {

        const form = <div className='p-4'>
           <h2 className='mb-0'>Crear nuevo flujo</h2>
                    {formulario_crear_flujo()}
        </div>
        return <div>
            <Button size="small" className='mb-3' onClick={() => setShowModal(true)}>CREAR NUEVO FLUJO</Button>
            <Modal width={"80%"} show={showModal} onHide={() => handleCancel()}>
               {form}
            </Modal>
        </div>
    }

    const editarFlujo = (id, val) => {
        setFlujos(prev => {
            let actual = [...prev]
            const i = actual.findIndex(f => f.flujo?._id === id)
            console.log({i, actual, id})
            if(i > -1 ) actual[i].flujo.edit = val
            return [...actual]
        })
    }

    const formularioEdicion =(flujo) => {

        const detalles_flujo = flujo.flujo ? flujo.flujo : {}

                    let tipos_servicio_elegidos = []

                                if(detalles_flujo.tipos_servicio){
                                    if(Array.isArray(detalles_flujo.tipos_servicio) !== false){
                                        if(detalles_flujo.tipos_servicio.length > 0){
                                            tipos_servicio_elegidos = tipos_servicio.filter(op => {
                                                return detalles_flujo.tipos_servicio.includes(op.value)
                                            })
                                        }
                                    }
        }

        if(!detalles_flujo?.edit === true) return <div>
            <h2>{detalles_flujo?.titulo} <Button size="sm" variant='light' onClick={() => editarFlujo(detalles_flujo._id, true)}><FaEdit /> EDITAR</Button> </h2>
        </div>

        return <div>
            <Card className='shadow mb-3 p-3'>
            <div className='row'>
                            <div className='col-md-4 mb-2'>
                                <label className='form-control-label d-block'>Título</label>
                                <input className='form-control' name="titulo" idflujo={detalles_flujo._id} placeholder='Escribe un nombre corto para recordar este flujo' defaultValue={detalles_flujo.titulo} onChange={handleChangeEditarFlujo} />
                            </div>
                            <div className='col-md-4 mb-2'>
                                <label className='form-control-label d-block'>Descripción</label>
                                <input className='form-control' name="descripcion" idflujo={detalles_flujo._id} placeholder='Describe este flujo' defaultValue={detalles_flujo.descripcion} onChange={handleChangeEditarFlujo} />
                            </div>
                            <div className='col-md-4 mb-2'>
                                <label className='form-control-label d-block'>Tipos servicio</label>
                                <Select 
                                style={{ marginBottom: 10 }}
                                onChange={(e) => handleChangeSelectTipoServicioEditar(e,detalles_flujo._id)}
                                defaultValue={tipos_servicio_elegidos}
                                options={tipos_servicio}
                                isMulti={true}
                                placeholder="Tipo de servicio..."
                                />
                            </div>
                            <div className='col-md-12 mb-2'>
                                <Row>
                                    <Col md={6}>
                                        
                                    <button disabled={idGuardandoFlujo === detalles_flujo._id} className='btn btn-sm btn-success mr-2' onClick={()=>actualizarFlujo(detalles_flujo)}>GUARDAR CAMBIOS</button>
                                    
                                    <Button disabled={idGuardandoFlujo === detalles_flujo._id} variant='secondary' size="sm" onClick={() => editarFlujo(detalles_flujo._id, false)} >CANCELAR</Button>
                                    </Col>
                                    <Col md={6} className='text-right'><button disabled={idGuardandoFlujo === detalles_flujo._id} className='btn btn-sm btn-outline-danger' onClick={()=>solicitarEliminarFlujo(detalles_flujo._id)} >ELIMINAR</button></Col>
                                </Row>
                                
                            </div>
                        </div>
                        </Card>
        </div>
    }

    const mostrar_registros = (registros) => {
        if(loadingFlujos === true) return <PantallaCargando />
        if(loadingEstadosCarga === true) return <PantallaCargando />

        const presentacion = <div className='p-5 bg-white'>
                <Row className="justify-content-md-center">
                    <Col md={6} className="text-center">
                        <h1><b>Flujo del protocolo</b></h1>
                        <Row className="justify-content-md-center">
                            <Col md={3}>
                                <TiFlowSwitch size={iconSize} />
                                <h5 className="mb-0" style={{ fontSize: 13, fontWeight: "bold" }}>Cada evento lleva a otro</h5>
                            </Col>
                            <Col md={3}>
                                <TiFlowParallel size={iconSize} />
                                <h5 className="mb-0" style={{ fontSize: 13, fontWeight: "bold" }}>Controla por tipo de servicio</h5>
                            </Col>
                        </Row>
                        <img src={`${url_images}/animations/orders.gif`} style={{ width: "50%" }} />
                        <p>Puedes crear flujos para controlar la forma en que los estados estarán disponibles en app de conductores y la web</p>
                        {modalCreacion()}
                        {/* <Link to={`/${rutas.centinela_nuevo.slug}`}><Button size="sm" variant="primary">MIS REGLAS DE NEGOCIO</Button></Link> */}
                    </Col>
                </Row>
            </div>

        if(registros.length < 1) return <div>{presentacion}</div>

        const estados_carga_selector = estadosCarga.map(estado => ({ value: estado._id, label: estado.titulo })) 
        estados_carga_selector.unshift({ value:'', label:'Ninguno' })
        return <div>
            {/* <h2>Mis flujos</h2> */}
            {modalCreacion()}
            {
                registros.map(flujo => {
                    const detalles_flujo = flujo.flujo ? flujo.flujo : {}

                    let tipos_servicio_elegidos = []

                                if(detalles_flujo.tipos_servicio){
                                    if(Array.isArray(detalles_flujo.tipos_servicio) !== false){
                                        if(detalles_flujo.tipos_servicio.length > 0){
                                            tipos_servicio_elegidos = tipos_servicio.filter(op => {
                                                return detalles_flujo.tipos_servicio.includes(op.value)
                                            })
                                        }
                                    }
                                }
                    return <div className='card p-3 mb-3' key={detalles_flujo._id}>
                        
                        {formularioEdicion(flujo)}
                        
                        {loadingCreacionSegmento === true ? <Spinner animation='border' /> : <Button variant='light' className='mb-3' onClick={()=>agregarSegmento(detalles_flujo._id)}><FaPlus /> AGREGAR PASO</Button>}
                        <h5>{flujo.segmentos.length < 1 ? 'Sin pasos creados' : `${flujo.segmentos.length} ${flujo.segmentos.length === 1 ? "Paso" : "Pasos" }`}</h5>

                        {
                            flujo.segmentos.map((segmento,i) => {
                                let opciones_tipo_servicio_elegidas = []

                                if(segmento.estados_disponibles){
                                    if(Array.isArray(segmento.estados_disponibles) !== false){
                                        if(segmento.estados_disponibles.length > 0){
                                            opciones_tipo_servicio_elegidas = estados_carga_selector.filter(op => {
                                                return segmento.estados_disponibles.includes(op.value)
                                            })
                                        }
                                    }
                                }

                                let opcion_defecto =  false
                                if(typeof segmento.estado_requerido === 'string'){
                                    const i = estados_carga_selector.findIndex(es => es.value === segmento.estado_requerido)
                                    if(i > -1) opcion_defecto = estados_carga_selector[i]
                                }
                                return <div className='card p-3 mb-3'>
                                    <h3>Paso {i+1}</h3>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label className='form-control-label d-block'>Estado requerido</label>
                                            <Select 
                                                style={{ marginBottom: 10 }}
                                                onChange={(e)=>handleChangeSelectEstadoCarga(e,segmento._id,detalles_flujo._id)}
                                                options={estados_carga_selector}
                                                defaultValue={opcion_defecto}
                                                placeholder={`Estado requerido...`}
                                                />    
                                        </div>
                                        <div className='col-md-4 '>
                                            <label className='form-control-label d-block'>Estados permitidos</label>
                                            <Select 
                                                style={{ marginBottom: 10 }}
                                                onChange={(e)=>handleChangeSelectEstadosDisponibles(e,segmento._id,detalles_flujo._id)}
                                                isMulti
                                                options={estados_carga_selector}
                                                defaultValue={opciones_tipo_servicio_elegidas}
                                                placeholder="Estado requerido..."
                                                />    
                                        </div>
                                        <div className='col-md-2'>
                                            <label className='form-control-label d-block'>Click para guardar</label>
                                            {
                                                idGuardandoSegmento === segmento._id ? 
                                                <Spinner animation='border' />
                                                : 
                                                <button className='btn btn-sm btn-success' onClick={()=>guardarCambiosSegmento(segmento)} >GUARDAR CAMBIOS</button>
                                            }
                                        </div>
                                        <div className='col-md-2'>
                                            <label className='form-control-label d-block'>Click para eliminar</label>
                                            {
                                                idGuardandoSegmento === segmento._id ? 
                                                <Spinner animation='border' />
                                                : 
                                                <button className='btn btn-sm btn-outline-danger' onClick={()=>solicitarEliminarSegmento(segmento._id, detalles_flujo._id)} >ELIMINAR</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                })
            }
        </div>
    }

                            
    return <div>
        {mostrar_registros(flujos)}
    </div>
}

export default FlujosEstadosCarga